import { z } from 'zod'
import { AgreementType, AgreementVersionWire } from './agreement.supabase.schema'

// GET /api/agreement/active — public.
export const GetActiveAgreementsResponse = z.object({
  data: z.array(AgreementVersionWire),
})
export type GetActiveAgreementsResponse = z.infer<typeof GetActiveAgreementsResponse>

// GET /api/agreement/missing — auth required.
export const GetMissingConsentsResponse = z.object({
  data: z.array(AgreementType),
})
export type GetMissingConsentsResponse = z.infer<typeof GetMissingConsentsResponse>

// POST /api/agreement/consent — auth required.
export const CreateConsentsRequest = z.object({
  agreement_version_ids: z.array(z.number().int().positive()).min(1).max(20),
  consent_url: z.string().max(2000),
})
export type CreateConsentsRequest = z.infer<typeof CreateConsentsRequest>

export const CreateConsentsResponse = z.object({
  created: z.number().int().nonnegative(),
})
export type CreateConsentsResponse = z.infer<typeof CreateConsentsResponse>
